import * as React from "react";
import { HeadFC, graphql } from "gatsby";

// page layout:
import { Layout } from "@/layout/Layout";
import { Seo } from "@comps/shared/Seo";

// Page sections
import { ContentSection } from "./sections/01/Section";
import { RelatedSection } from "./sections/03/Section";
import { usePageContext } from "@/contexts/Page";

const Post: React.FC = ({ data, pageContext }: any) => {
  const { wpPost } = data;

  const { updateContext, updateLanguage } = usePageContext();
  
  React.useEffect(() => {
    if (updateContext) {
      updateContext(
        pageContext.slug,
        pageContext.title,
        pageContext.content,
        pageContext.type
      );
    }

    // Cambiar el idioma según el slug
    if (wpPost.news.headerLanguage == "en") {
      updateLanguage("en");
    } else {
      updateLanguage("es");
    }
  }, []);
  
  return (
    <Layout headerTransition={false}>
      <main id="post-page">
        <ContentSection
          image={wpPost.featuredImage}
          content={wpPost.content}
          title={wpPost.title}
          date={wpPost.date}
        />
        <RelatedSection categories={wpPost.categories.nodes} />
      </main>
    </Layout>
  );
};

export default Post;
export const Head: HeadFC<{ wpPost: any }> = ({ data }) => {
  const { wpPost } = data;
  return (
    <Seo
      seoDescription={wpPost.seo.opengraphDescription}
      SeoImage={wpPost.seo.opengraphImage?.publicUrl}
      metaDescription={wpPost.seo.metaDesc}
      seoTitle={wpPost.seo.opengraphTitle}
      seoType={wpPost.seo.opengraphType}
      SeoUrl={wpPost.seo.opengraphUrl}
      metatitle={wpPost.seo.title}
    />
  );
};

export const pageQuery = graphql`
  query PostPageTemplate($slug: String!) {
    wpPost(slug: { eq: $slug }) {
      content
      title
      slug
      date
      id
      featuredImage {
        node {
          title
          altText
          gatsbyImage(
            fit: COVER
            quality: 100
            breakpoints: 3
            width: 1920
            formats: WEBP
          )
        }
      }
      seo {
        opengraphDescription
        opengraphTitle
        opengraphType
        opengraphUrl
        metaDesc
        title
        opengraphImage {
          publicUrl
        }
      }
      categories {
        nodes {
          slug
          name
        }
      }
      news {
        headerLanguage
      }
    }
  }
`;
